import { postSonarObjectSalesforceUpdateable } from '@api';
import { updateSonarObjectReferences } from '../_idMap/actions';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreSonarObjectsSalesforceUpdateableAsyncSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [
			(response) =>
				updateSonarObjectReferences(
					response?.map(({ sonarObjectId, ...salesforce }) => ({
						salesforce: {
							...salesforce.complianceCategory ?
								{ complianceCategory: salesforce.complianceCategory } : {},
							...salesforce.dataSensitivityLevelId ?
								{ dataSensitivityLevelId: salesforce.dataSensitivityLevelId } : {},
							...salesforce.fieldUsageId ?
								{ fieldUsageId: salesforce.fieldUsageId } : {}
						},
						sonarObjectId
					}))
				)
		]
	},
	name: 'CoreSonarObjectsSalesforceUpdateable',
	receive: true,
	request: true,
	requestHandler: postSonarObjectSalesforceUpdateable,
	yieldType: SagaYieldType.Latest
});
